import { render, staticRenderFns } from "./v20a7000.vue?vue&type=template&id=2acb0a8a&"
import script from "./v20a7000.vue?vue&type=script&lang=js&"
export * from "./v20a7000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports